import LeftNavBar from '@pages/AppWrapperViewComponent/LeftNavBar';
import NationalEmblem from '../../../../assets/svg_main/national_emblem.svg';
import React, { useEffect, useRef, useState } from 'react';
import '../Child/ChildComponent.css';
import BadgesComponent from '@components/common/Badges';
import { CommonHamburgar } from '@components/common/CommonHamburgar';
import Button from '../../../../components/common/Button';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import BackArrowsvg from '../../../../assets/svg_main/BackArrowIconSvg.svg';
import profilePic from '../../../../assets/png/default_profile.png';
import endpoints from '@config/endpoints';
import WomanIcon from '../../../../assets/svg_main/Woman.svg';
import ManIcon from "../../../../assets/svg_main/Man.svg";
import { childDetails, dateFormate, fatherDetails, guardianDetails, motherDetails } from '@constants/index';
import CommonFormFields from '@pages/Forms/CommonFormFields';
import ToggleButton from '../Child/Toggle';
import dayjs from 'dayjs';
import config from '@config/config';
import { imageData, setChildBenefList, updateChild, updateChildVerifyFromGrid } from '@store/actions/beneficiaryAction';
import { useSelector } from 'react-redux';
import { RootState } from '@store/reducers';
import AlertPopup from './AlertPopup';
import ProgressBarComponent from '@components/common/ProgressBar';
import InfoBar from '@components/common/InfoBars';
import { toast } from 'react-toastify';
import BreadcrumbComponent from '@components/common/Breadcrumb';
import { getData, getDataWithCache, postDataJSON, putDataJSON } from '../../../../services/CommonApiService';
import { decodeWithKeyAndShift, encodeWithKeyAndShift } from '../../../../utils/base64Utils';
import EditIcon from '../../../../assets/svg_main/pencil-01.svg';
import CustomTooltip from '@components/common/CustomTooltip';
import axios from '@utils/axiosExt';
import Auth from '@utils/auth';
import convertByteToImageURL from '@utils/convertByteToImageURL';
import { errorLogger } from '@utils/applicationLogUtils';
import { CHILD_ERRORS, getPNCDetails } from '../DeliveryOutcome/constants/DeliveryConstants';
import { getHBYCPeriodDetails } from '@utils/commonUtils';
import { benef_const } from '@constants/beneficiaryConstant';
import { AUTH_TYPES, BENEFICIARY_OPTIONS, CHILD_REGISTRATION_KEYS } from '@constants/childTrackingConstant';
import Loading from "@components/common/Loading";

interface ChildProps {
  page: string;
  flow: string;
}

interface objectType {
  isError: boolean;
  message: string;
  isDisable: boolean;
  value: any;
  id?: any;
  code?: any;
}

export interface formStateType {
  [key: string]: objectType;
}

const CreateNewChild = (props: ChildProps) => {
  
  const { state } = useLocation();
  const decodedData = JSON.parse(decodeWithKeyAndShift(state));
  const benfDetails = decodedData;
  const { page, flow } = props;
  const { id } = useParams();

  const childImageData = useSelector((state: RootState) => state.beneficiary?.childImageData);

  const childModalImageFile = useSelector((state: RootState) => state.beneficiary?.childModalImageFile);
  const createSubmitClicked = useSelector((state: RootState) => state.beneficiary?.createSubmitClicked);
  const verifySubmitClicked = useSelector((state: RootState) => state.beneficiary?.verifySubmitClicked);
  const childRegistrationId = useSelector((state: RootState) => state.beneficiary?.childRegistrationId);
  const childFlow=useSelector((state: RootState) => state.beneficiary?.childFlow);
  const childVerifyFromGrid = useSelector((state: RootState) => state.beneficiary?.childVerifyFromGrid);
  const regChildDetails = useSelector((state: RootState) => state.beneficiary?.regChildDetails);
  const verifiedChildDetails = useSelector((state: RootState) => state.beneficiary?.verifiedChildDetails);
  const childConsentIds = useSelector((state: RootState) => state.beneficiary?.childConsentIds);
  const beneficiaryAuthType = useSelector((state: RootState) => state.beneficiary.beneficiaryAuthType);
  const beneficiaryRedgeOption = useSelector((state: RootState) => state.beneficiary.beneficiaryRedgeOption);
  const [beneficiary, setBeneficiary] = useState<any>(benfDetails?.beneficiary);
  const [tabs, setTabs] = useState<any>(['Child Details']);
  const [currentTab, setCurrentTab] = useState('Child Details');
  const [alertModalOpen, setAlertModalOpen] = useState<boolean>(false)
  const [benfImageUrl, setBenfImageUrl] = useState<any>();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [newImageUrl, setNewImageUrl] = useState<any>(null);
  const [imageError, setImageError] = useState('');
  const inputRef = useRef<any>(null);
  const [uploadMethod, setUploadMethod] = useState<'local' | 'url' | null>(
    null,
  );
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleBack = () => {
    dispatch(updateChildVerifyFromGrid(false));
    dispatch(updateChild("updateChildVerifyFromView", false)); 
    dispatch(updateChild('verifyChildFromGridData', {}));
    dispatch(updateChild("childFlow", ''));
    navigate(-1);
  };

  const [verify, setVerify] = useState<boolean>(true);
  const [fatherFormState, setFatherFormState] = useState<formStateType>({
    name: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
    },
    mob: {
      isError: false,
      message: '',
      id: '',
      isDisable: false,
      value: '',
    },
  });
  const [fatherData, setFatherData] = useState<any>(fatherDetails);
  const [guardianFormState, setGuardianFormState] = useState<formStateType>({
    name: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
    },
    mob: {
      isError: false,
      message: '',
      id: '',
      isDisable: false,
      value: '',
    },
  });
  const [guardianData, setGuardianData] = useState<any>(guardianDetails);
  const [motherData, setMotherData] = useState<any>(motherDetails);
  const [motherFormState, setMotherFormState] = useState<formStateType>({
    name: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
    },
    mob: {
      isError: false,
      message: '',
      id: '',
      isDisable: false,
      value: '',
    },
  });
  const [childFormState, setChildFormState] = useState<formStateType>({
    childAbha: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
    },
    abhaAddress: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
    },
    dateOfreg: {
      isError: false,
      message: '',
      id: '',
      isDisable: false,
      value: dayjs(new Date()),
    },
    timeOfreg: {
      isError: false,
      message: '',
      id: '',
      isDisable: false,
      value: dayjs(new Date()),
    },
    relationWithChild: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
    },
    name: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
    },
    dob: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
    },
    timeOfbirth: {
      isError: false,
      message: '',
      isDisable: false,
      value: null,
    },
    gender: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
    },
    maturity: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
    },
    weight: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
    },
    checkboxToggle: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
    },
    facilityType: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
      id:'',
    },
    facilityName: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
      id:'',
    },
    healthProviderName: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
      id:'',
    },
    ashaName: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
      id:'',
    },
    dateOfVisit: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
    },
  });
  const [isMotherAlive, setIsMotherAlive] = useState<boolean>(true);
  const [childData, setChildData] = useState<any>(childDetails);
  const [fatherToggle, setFatherToggle] = useState<boolean>(false);
  const [motherToggle, setMotherToggle] = useState<boolean>(false);
  const [guardianToggle, setGuardianToggle] = useState<boolean>(false);
  const [isFormCompleted, setIsFormCompleted] = useState<boolean>(false);
  const [perc, setPerc] = useState<any>(0);
  const userId = localStorage.getItem('userId');
  const [child, setChild] = useState<any>([]);
  const [genderOptions, setGenderOptions] = useState<any>([]);
  const [relationOptions, setRelationOptions] = useState<any>([]);
  const [loginId, setLoginId] = useState<string>('');
  const [isAadhaarFlow, setIsAadhaarFlow] = useState<boolean>(false);
  const [regId, setRegId] = useState<string>('');
  const isTempBenf = benfDetails?.beneficiaryDetails?.abha_id;

  const shouldRenderMotherDetails = (isMotherAlive &&
    (childFormState.relationWithChild?.value === "Guardian" || !childFormState.relationWithChild?.value || childFormState.relationWithChild?.value ==="Father"));
  const shouldRenderFatherDetails = (childFormState.relationWithChild?.value === "Guardian" ||
    !childFormState.relationWithChild?.value ||
    childFormState.relationWithChild?.value === "Mother");
  useEffect(() => {
    if (isMotherAlive) {
      setFatherData((prevState: any) => ({
        ...prevState,
        name: {
          ...prevState.name,
          '#required': false,
        },
        mob: {
          ...prevState.mob,
          '#required': false,
        },
      }));

      setGuardianData((prevState: any) => ({
        ...prevState,
        name: {
          ...prevState.name,
          '#required': false,
        },
        mob: {
          ...prevState.mob,
          '#required': false,
        },
      }));

      setChildData((prevState: any) => ({
        ...prevState,
        relationWithChild: {
          ...prevState.relationWithChild,
          '#options': relationOptions,
        },
      }));
    } else {
      setFatherData((prevState: any) => ({
        ...prevState,
        name: {
          ...prevState.name,
          '#required': true,
        },
        mob: {
          ...prevState.mob,
          '#required': true,
        },
      }));

      setGuardianData((prevState: any) => ({
        ...prevState,
        name: {
          ...prevState.name,
          '#required': true,
        },
        mob: {
          ...prevState.mob,
          '#required': true,
        },
      }));
      let updatedRelationOptions = [];
      if (beneficiary.gender_name === "Male") {
        updatedRelationOptions = relationOptions.filter((item: any) => item.value !== 'Mother');
      } else {
        updatedRelationOptions = relationOptions.filter((item: any) => item.value === 'Guardian');
      }

      setChildData((prevState: any) => ({
        ...prevState,
        relationWithChild: {
          ...prevState.relationWithChild,
          '#options': updatedRelationOptions,
        },
      }));

      if (childFormState.relationWithChild.value === 'Mother') {
        setChildFormState((prevState: any) => ({
          ...prevState,
          relationWithChild: {
            ...prevState.relationWithChild,
            value: '',
          },
        }));
      }
    }
  }, [isMotherAlive]);

  useEffect(() => {
    setChildData((prevState: any) => ({
      ...prevState,
      checkboxToggle: {
        ...prevState.checkboxToggle,
        '#isMotherAlive': isMotherAlive,
      },
    }));
    
    if (!isTempBenf) {
      setChildData((prevState: any) => ({
        ...prevState,
        childAbha: {
          ...prevState.childAbha,
          '#required': false,
          '#isDisabled': true,
        },
        abhaAddress: {
          ...prevState.abhaAddress,
          '#required': false,
          '#isDisabled': true,
        },
      }));
    }
     
    initialFetch();
    fetchBenfImage(beneficiary?.benef_id);
    dispatch(updateChild("parentAbha", beneficiary?.abha_id));


    return (): any => {
      dispatch(updateChild('verifySubmitClicked', false));
      dispatch(updateChild('createSubmitClicked', false));
      dispatch(updateChild('verifiedChildDetails', {}));
      dispatch(updateChild('regChildDetails', {}));
      dispatch(updateChild('childModalImageFile', null));
      dispatch(updateChild('childImageData', null));
      dispatch(updateChildVerifyFromGrid(false));
      dispatch(updateChild('verifyChildFromGridData', {}));
      dispatch(updateChild("childFlow", ''));
      dispatch(updateChild('childConsentIds',[]));
      dispatch(updateChild('childRegistrationId', ''));
      dispatch(updateChild('isChildRegistration', false));
    }
  }, []);

  const shouldRenderGuardianDetails = () => {
    const relation = childFormState.relationWithChild?.value;
    if (beneficiary?.gender_name === "Female" && isMotherAlive) {
      return  relation === "Father" || !relation || relation === "Mother"
    }else{
      return  relation === "Father" || !relation || relation === "Mother"
    }
  };

  const fetchBenfImage = async (benfId: string) => {
    try {
      const res = await getData<any>(`${endpoints.getImageByBeneficiaryID(benfId)}`);
      if (res?.data[0]) {
        const imageurl = res?.data[0]?.image?.data ? convertByteToImageURL(res.data[0].image.data) : null;
        setBenfImageUrl(imageurl);
      }
    }        catch(error:any){
      errorLogger(error?.response?.data||error?.response||error)
    }
  }

  useEffect(() => {
    if (childModalImageFile instanceof File) {
      const childModalImageURL = URL.createObjectURL(childModalImageFile);
      setNewImageUrl(childModalImageURL);

      const formData = new FormData();
      formData.append('file', childModalImageFile);
      dispatch(updateChild('childImageData', formData));
    } else {
      setNewImageUrl(null);
    }
  }, [childModalImageFile]);

  useEffect(() => {
    if (Object.keys(regChildDetails).length > 0) {
      handleProcessIds();
      const gender = regChildDetails?.gender === 'M' ? 'Male' : 'Female';
      const genderId = getGenderId(gender);
      const fullName = [regChildDetails?.firstName, regChildDetails?.middleName, regChildDetails?.lastName].filter(Boolean).join(' ');
      const abhaNum = regChildDetails?.ABHANumber?.split('-')?.join('');
      setChildFormState((prevState: any) => ({
        ...prevState,
        childAbha: {
          ...prevState.childAbha,
          value: abhaNum,
          isDisable: true,
        },
        abhaAddress: {
          ...prevState.abhaAddress,
          value: regChildDetails?.phrAddress ? regChildDetails.phrAddress : `${abhaNum}@sbx`,
          isDisable: true,
        },
        name: {
          ...prevState.name,
          value: fullName,
          isDisable: true,
        },
        dob: {
          ...prevState.dob,
          value: regChildDetails?.dob !== '' ? dayjs(regChildDetails?.dob, dateFormate.dd_m_yyyy) : '',
          isDisable: regChildDetails?.dob === '',
        },
        gender: {
          ...prevState.gender,
          value: gender,
          isDisable: true,
          id: genderId,
        },
        timeOfbirth: {
          ...prevState.timeOfbirth,
          isDisable: regChildDetails?.dob === ''
        },
      }));

      setChildData((prevState: any) => ({
        ...prevState,
        childAbha: {
          ...prevState.childAbha,
          '#isDisabled': true,
        },
        abhaAddress: {
          ...prevState.abhaAddress,
          '#isDisabled': true,
        },
        name: {
          ...prevState.name,
          '#isDisabled': true,
        },
        dob: {
          ...prevState.dob,
          '#isDisabled': regChildDetails?.dob !== '',
        },
        gender: {
          ...prevState.gender,
          '#isDisabled': true,
        },
        timeOfbirth: {
          ...prevState.timeOfbirth,
          '#maxDate': regChildDetails?.dob !== '' ? dayjs(regChildDetails?.dob, dateFormate.dd_m_yyyy) : '',
          '#minDate': regChildDetails?.dob !== '' ? dayjs(regChildDetails?.dob, dateFormate.dd_m_yyyy) : '',
          '#isDisabled': regChildDetails?.dob === '',
        },
      }));
    }
  }, [regChildDetails, genderOptions]);
  

  useEffect(() => {
    if (Object.keys(verifiedChildDetails).length > 0) {
      handleProcessIds();
      const gender = verifiedChildDetails?.gender === 'M' ? 'Male' : 'Female';
      const genderId = getGenderId(gender);
      setChildFormState((prevState: any) => ({
        ...prevState,
        childAbha: {
          ...prevState.childAbha,
          value: verifiedChildDetails?.ABHANumber?.split('-')?.join(''),
          isDisable: true,
        },
        abhaAddress: {
          ...prevState.abhaAddress,
          value: verifiedChildDetails?.phrAddress,
          isDisable: verifiedChildDetails?.phrAddress ? true : false,
        },
        name: {
          ...prevState.name,
          value: verifiedChildDetails?.name,
          isDisable: true,
        },
        dob: {
          ...prevState.dob,
          value: verifiedChildDetails?.dateOfBirth !== '' ? dayjs(verifiedChildDetails?.dateOfBirth, dateFormate.dd_m_yyyy) : '',
          isDisable: verifiedChildDetails?.dateOfBirth !== '',
        },
        gender: {
          ...prevState.gender,
          value: gender,
          isDisable: true,
          id: genderId,
        },
      }));
      setChildData((prevState: any) => ({
        ...prevState,
        childAbha: {
          ...prevState.childAbha,
          '#isDisabled': true,
        },
        abhaAddress: {
          ...prevState.abhaAddress,
          '#isDisabled': verifiedChildDetails?.phrAddress ? true : false,
        },
        name: {
          ...prevState.name,
          '#isDisabled': true,
        },
        dob: {
          ...prevState.dob,
          '#isDisabled': verifiedChildDetails?.dateOfBirth !== '',
        },
        gender: {
          ...prevState.gender,
          '#isDisabled': true,
        },
        timeOfbirth: {
          ...prevState.timeOfbirth,
          '#maxDate': verifiedChildDetails?.dateOfBirth !== '' && dayjs(verifiedChildDetails?.dateOfBirth, dateFormate.dd_m_yyyy),
          '#minDate': verifiedChildDetails?.dateOfBirth !== '' && dayjs(verifiedChildDetails?.dateOfBirth, dateFormate.dd_m_yyyy),
          '#isDisabled': verifiedChildDetails?.dateOfBirth === '',
        },
      }));
    }
  }, [verifiedChildDetails, genderOptions]);

  useEffect(() => {
    dispatch(updateChild("childBALABHAIds", benfDetails?.childBalABHAIds));
  }, [benfDetails]);

  // useEffect(() => {
  //   const intervalId = setInterval(() => {
  //     setChildFormState((prevState: any) => ({
  //       ...prevState,
  //       timeOfreg: {
  //         ...prevState.timeOfreg,
  //         value: dayjs(new Date()),
  //       },
  //     }));
  //   }, 1000);

  //   return () => clearInterval(intervalId);
  // }, []);

  const storeUserId = localStorage.getItem('userId');
  const childGenderOptions = localStorage.getItem('childGenderOptions');
  const childMaturityOptions = localStorage.getItem('childMaturityOptions');
  const childRelationOptions = localStorage.getItem('childRelationOptions');

  const initialFetch = async () => {
   setIsLoading(true)
    try {
      const facilityDetailsRespone = await getDataWithCache<any>(`${endpoints.getLinkedFacilitiesByUserById}/${userId}`);
      const parentFacility = facilityDetailsRespone.data[0]?.find((item: any) => item.is_parent === true);
      const facilityTypeOptions = facilityDetailsRespone?.data[0]?.map((key: any) => ({
        value: key.facility_type_name,
        label: key.facility_type_name,
        id: key.facility_type_id,
        code: key.facility_type_code,
      }),
      )?.filter((item: any, index: number, self: any[]) =>
        index === self.findIndex((t) => t.id === item.id)
      );
      
      const facilityNameOptions = facilityDetailsRespone?.data[0]?.map((key: any) => ({
        value: key.facility_name,
        label: key.facility_name,
        id: key.facility_id,
        code: key.facility_code,
      }),
      );
      const Health_provider = parentFacility?.facility_id
        ? await getDataWithCache<any>(`${endpoints.getHealthProviderTagged(parentFacility?.facility_id)}`)
        : null;
      const healthProviderOptions = Health_provider?.data?.map((key: any) => ({
        value: `${key?.f_name} ${key?.l_name}`,
        label: `${key?.f_name} ${key?.l_name}`,
        id: key?.user_id,
        code: key?.user_code,
        ufTaggedId: key?.uf_tagged_id,
      })) ?? [];

      const userDetail = await getData<any>(`${endpoints.getUserById}/${userId}`);
      const currUserName = userDetail.data[0].first_name + ' ' + userDetail.data[0].middle_name + ' ' + userDetail.data[0].last_name;
      const healthProviderData = Health_provider?.data?.find((item: any) => `${item.f_name} ${item.l_name}` === currUserName.replace('null', '').replace('  ', ' '));
      const healthProviderName = healthProviderData
        ? `${healthProviderData.f_name ?? ''} ${healthProviderData.l_name ?? ''}`.trim()
        : '';

      const ashaNameRes = healthProviderData?.uf_tagged_id
        ? await getDataWithCache<any>(`${endpoints.getMobiliserTagged(healthProviderData?.uf_tagged_id)}`)
        : null;
      const ashanameOptions = ashaNameRes?.data?.map((key: any) => ({
        value: key.f_name + " " + key.l_name,
        label: key.f_name + " " + key.l_name,
        id: key.mobiliser_id,
        code: key?.user_code
      })) ?? [];


      setChildData((prevState: any) => ({
        ...prevState,
        facilityType: {
          ...prevState.facilityType,
          '#options': facilityTypeOptions ?? [],
        },
        facilityName: {
          ...prevState.facilityName,
          '#options': facilityNameOptions ?? [],
        },
        healthProviderName: {
          ...prevState.healthProviderName,
          '#options': healthProviderOptions ?? [],
        },
        ashaName: {
          ...prevState.ashaName,
          '#options': ashanameOptions ?? [],
        },
      }));

      setChildFormState((prevState: any) => ({
        ...prevState,
        facilityType: {
          ...prevState.facilityType,
          value: facilityTypeOptions.length === 1 ? parentFacility?.facility_type_name : '',
          id: facilityTypeOptions.length === 1 ? parentFacility?.facility_type_id : ''
        },
        facilityName: {
          ...prevState.facilityName,
          value: facilityNameOptions.length === 1 ? parentFacility?.facility_name : '',
          id: facilityNameOptions.length === 1 ? parentFacility?.facility_id : ''
        },
        healthProviderName:{
          ...prevState.healthProviderName,
          value: healthProviderName,
          id: healthProviderData?.user_id,
          label: healthProviderName,
          code: healthProviderData?.user_code,
          ufTaggedId: healthProviderData?.uf_tagged_id,
        },

      }));
      
      let genderData : any= [];
      if (storeUserId && childGenderOptions) {
        genderData = JSON.parse(decodeWithKeyAndShift(childGenderOptions));
      } else {
        genderData = await getDataWithCache<any>(endpoints.getChildGender);
        localStorage.setItem('childGenderOptions', encodeWithKeyAndShift(JSON.stringify(genderData)));
      }
        const genderOptionsData = genderData?.data?.[0]?.map((key: any) => ({
          value: key.gender_name,
          label: key.gender_name,
          id: key.gender_id,
          code: key.gender_code,
        }));
        
      setGenderOptions(genderOptionsData);
      setChildData((prevState: any) => ({
        ...prevState,
        gender: {
          ...prevState.gender,
          '#options': genderOptionsData,
        },
      }));

      let maturityData : any= [];
      if(storeUserId && childMaturityOptions){
        maturityData = JSON.parse(decodeWithKeyAndShift(childMaturityOptions));
      }
      else {
        maturityData = await getDataWithCache<any[]>(endpoints.getMaturity);
        localStorage.setItem('childMaturityOptions', encodeWithKeyAndShift(JSON.stringify(maturityData)));
      }
        const maturityOptions = maturityData?.data?.map((key: any) => ({
          value: key.maturity_name,
          label: key.maturity_name,
          id: key.maturity_id,
          code: key.maturity_code,
        }));
        
      setChildData((prevState: any) => ({
        ...prevState,
        maturity: {
          ...prevState.maturity,
          '#options': maturityOptions,
        },
      }));

      let relationOptions = [];
      let relationData : any = [];
      if(storeUserId && childRelationOptions){
        relationData = JSON.parse(decodeWithKeyAndShift(childRelationOptions));
      }
      else{
        relationData = await getDataWithCache<any[]>(endpoints.getRelation);
        localStorage.setItem('childRelationOptions', encodeWithKeyAndShift(JSON.stringify(relationData)));
      }
      if (beneficiary.gender_name === "Female") {
        relationOptions = relationData?.data[0]
          ?.filter((key: any) => key.relationship_name !== "Father") // Remove "Father"
          .map((key: any) => ({
            value: key.relationship_name,
            label: key.relationship_name,
            id: key.relationship_id,
            code: key.relationship_code,
          }));
      } else {
        relationOptions = relationData?.data[0]
          ?.filter((key: any) => key.relationship_name !== "Mother") // Remove "Mother"
          .map((key: any) => ({
            value: key.relationship_name,
            label: key.relationship_name,
            id: key.relationship_id,
            code: key.relationship_code,
          }));
      }
      setRelationOptions(relationOptions);
      setChildData((prevState: any) => ({
        ...prevState,
        relationWithChild: {
          ...prevState.relationWithChild,
          '#options': relationOptions,
        },
      }));
      if(childVerifyFromGrid){
        const childResponse = await getData<any>(`${endpoints.childBeneficiaryById}/${benfDetails.childBenfId}`);
        setChild(childResponse?.data[0]);
        setChildFormState((prevState: any) => ({
          ...prevState,
          ['maturity']: {
            ...prevState['maturity'],
            value: childResponse?.data[0].maturity_status_name,
            id: childResponse?.data[0].maturity_status_id,
          },
          ['weight']: {
            ...prevState['weight'],
            value: childResponse?.data[0].weight_at_birth_in_gm
          },
          ['relationWithChild']: {
            ...prevState['relationWithChild'],
            value: childResponse?.data[0].relationship_name,
            id:childResponse?.data[0].relationship_id,
            code:childResponse?.data[0].relationship_code
          },
          ['benef_id']:{
            ...prevState['relationWithChild'],
            value: childResponse?.data[0].relationship_name,
            id:childResponse?.data[0].relationship_id,
            code:childResponse?.data[0].relationship_code
          },
          timeOfbirth: {
            ...prevState.timeOfbirth,
            value:dayjs(childResponse?.data[0].dob)
          },
        }));
        setIsMotherAlive(childResponse?.data[0].is_mother_alive);
      }
     setIsLoading(false)
    }        catch(error:any){
      setIsLoading(false)
      errorLogger(error?.response?.data||error?.response||error)
    }
  };

  const getGenderId = (gender: any) => {
    const genderOption = genderOptions.find((item: any) => item.value === gender);
    return genderOption ? genderOption.id : null;
  };

  const onClickVerify = (value: boolean) => {
    // if (value === true) {
    //   setChildFormState((prevState: any) => ({
    //     ...prevState,
    //     childAbha: {
    //       ...prevState.childAbha,
    //       isError: true,
    //       message: 'ABHA Number Must Contain 14 Digits. Enter a valid ABHA Number.',
    //     },
    //   }));
    // }
  };
  const validateField = (value: any) => {
    return !/^[A-Za-z\s]+$/.test(value);
  }

  const handleChildFormChange =async (value: any, key: string, id: any, option: any, code: any, changedData?: any) => {    
    if (key === 'name' && value.length > 50) {
      return;
    }
    if (key === 'name' && validateField(value) && value) {
      return;
    }
    if(key === 'weight') {
      if (!/^(\d+(\.\d*)?|\.\d*|)$/.test(value)) {
        return;
      } else if (value > 10000) {
        return;
      }
    }
    if (key === 'isMotherAlive') {
      setIsMotherAlive(value);
      setChildData((prevState: any) => ({
        ...prevState,
        checkboxToggle: {
          ...prevState.checkboxToggle,
          '#isMotherAlive': value,
        },
      }));
      if (!value) {
        setFatherToggle(true);
      }
      else {
        setFatherToggle(false);
      }
    }
    if (key === 'dob') {
      validateDOB(value);
      const ninetyDaysAgo = dayjs().subtract(config.serviceDateLimit, 'day');
      const visitMinDate = dayjs(value).isAfter(ninetyDaysAgo) ? dayjs(value) : ninetyDaysAgo;
      setChildFormState((prevState: any) => ({
        ...prevState,
        timeOfbirth: {
          ...prevState.timeOfbirth,
          value: '',
        },
        ...(prevState.dateOfVisit.value && dayjs(prevState.dateOfVisit.value).isBefore(visitMinDate) ? {
          dateOfVisit: { ...prevState.dateOfVisit, value: '' },
        } : {}),
      }));
      setChildData((prevState: any) => ({
        ...prevState,
        timeOfbirth: {
          ...prevState.timeOfbirth,
          '#maxDate': dayjs(value),
          '#minDate': dayjs(value),
          '#isDisabled': false,
        },
        dateOfVisit: {
          ...prevState.dateOfVisit,
          '#minDate': visitMinDate,
        },
      }));
    }
    if (key === 'dob' && !value) {
      setChildFormState((prevState: any) => ({
        ...prevState,
        timeOfbirth: {
          ...prevState.timeOfbirth,
          value: '',
        },
      }));
      setChildData((prevState: any) => ({
        ...prevState,
        timeOfbirth: {
          ...prevState.timeOfbirth,
          '#isDisabled': true,
        },
        dateOfVisit: {
          ...prevState.dateOfVisit,
          '#minDate': dayjs().subtract(config.serviceDateLimit, 'day'),
        },
      }));
    }
    if (key === 'childAbha' && (value && (value.length > 14 || !(/^\d+$/.test(value))))) {
      return;
    }
    if (key === 'childAbha') {
      dispatch(updateChild("childBALAbhaId", value));
    }

    if (key === "healthProviderName") {      
      setChildFormState((prevState: any) => ({
        ...prevState,
        ashaName: {
          ...prevState.ashaName,
          value: '',
        }}));
      if (value) {
        try {
          const ashaNameRes = await getDataWithCache<any>(`${endpoints.getMobiliserTagged(changedData?.ufTaggedId)}`);
          const ashanameOptions = ashaNameRes?.data.map((key: any) => ({
            value: key?.f_name + ' ' + key?.l_name,
            label: key?.f_name + ' ' + key?.l_name,
            id: key?.mobiliser_id,
            code: key?.user_code,
          }));
          setChildData((prevState: any) => ({
            ...prevState,
            ashaName: {
              ...prevState.ashaName,
              '#options': ashanameOptions,
            },
          }));
        } catch (error:any) {
            errorLogger(error?.response?.data || error?.response || error)
        }
      } else {
        setChildData((prevState: any) => ({
          ...prevState,
          ashaName: {
            ...prevState.ashaName,
            '#options': [],
          },
        }));
      }
    }

    setChildFormState((prevState: any) => ({
      ...prevState,
      [key]: {
        ...prevState[key],
        value: value,
        id: id,
        code: code,
        isError: false,
        message: '',
      },
    }));
  };

  const validateDOB = (value: any) => {
    benfDetails.childDobs.forEach((item: any) => {
      if (item === dayjs(value).format('DD-MM-YYYY')) {
        setAlertModalOpen(true);
      }
    });
  }

  const closeAlertModal = (value: boolean) => {
    if (value) {
      setAlertModalOpen(false);
    }
    else {
      setAlertModalOpen(false);
      setChildFormState((prevState: any) => ({
        ...prevState,
        dob: {
          ...prevState.dob,
          value: '',
        },
      }));
    }
  }

  const handleFatherFormChange = (
    value: any,
    key: string,
    id: any,
    option: any,
    code: any,
  ) => {
    if (key === 'name' && value.length > 50) {
      return;
    }

    if (key === 'name' && validateField(value) && value) {
      return;
    }

    setFatherFormState((prevState: any) => ({
      ...prevState,
      [key]: {
        ...prevState[key],
        value: value,
        id: id,
        code: code,
        isError: false,
        message: '',
      },
    }));
  };

  const handleMotherFormChange = (
    value: any,
    key: string,
    id: any,
    option: any,
    code: any,
  ) => {
    if (key === 'name' && value.length > 50) {
      return;
    }

    if (key === 'name' && validateField(value) && value) {
      return;
    }

    setMotherFormState((prevState: any) => ({
      ...prevState,
      [key]: {
        ...prevState[key],
        value: value,
        id: id,
        code: code,
        isError: false,
        message: '',
      },
    }));
  };

  const handleGuardianFormChange = (
    value: any,
    key: string,
    id: any,
    option: any,
    code: any,
  ) => {
    if (key === 'name' && value.length > 50) {
      return;
    }

    if (key === 'name' && validateField(value) && value) {
      return;
    }
    setGuardianFormState((prevState: any) => ({
      ...prevState,
      [key]: {
        ...prevState[key],
        value: value,
        id: id,
        code: code,
        isError: false,
        message: '',
      },
    }));
  };

  const handleToggleChange = (value: any, toggleType: string) => {
    if (!isMotherAlive && beneficiary.gender_name === "Female") {
      if (!guardianToggle && toggleType === "father" && !value) {
        return;
      }
      if (!fatherToggle && toggleType === "guardian" && !value) {
        return;
      }
    }

    if (toggleType === 'father') {
      setFatherToggle(value);
    }
    else if (toggleType === 'guardian') {
      setGuardianToggle(value);
    } else if (toggleType === 'mother') {
      setMotherToggle(value);
    }
  };

  const handleChildSave = (): boolean => {
    let checkError = false
    if (!childFormState.name.value?.trim()) {
      setChildFormState((prevState: any) => ({
        ...prevState,
        name: {
          ...prevState.name,
          isError: true,
          message: CHILD_ERRORS.NAME,
        },
      }));
      checkError = true;
    }
    else if (!/^[a-zA-Z\s]+$/.test(childFormState.name.value)) {
      setChildFormState((prevState: any) => ({
        ...prevState,
        name: {
          ...prevState.name,
          isError: true,
          message: 'Entered child name is invalid. Number & Special characters are not allowed.',
        },
      }));
      checkError = true;
    }
    if (!childFormState.dob.value || !dayjs(childFormState.dob.value).isValid() || dayjs(childFormState.dob.value).isAfter(dayjs())) {
      setChildFormState((prevState: any) => ({
        ...prevState,
        dob: {
          ...prevState.dob,
          isError: true,
          message: CHILD_ERRORS.DOB,
        },
      }));
      checkError = true;
    }
    if (!childFormState.gender.value || !childFormState.gender.id) {
      setChildFormState((prevState: any) => ({
        ...prevState,
        gender: {
          ...prevState.gender,
          isError: true,
          message: CHILD_ERRORS.GENDER,
        },
      }));
      checkError = true;
    }
    // if (!childFormState.abhaAddress.value && isTempBenf) {
    //   setChildFormState((prevState: any) => ({
    //     ...prevState,
    //     abhaAddress: {
    //       ...prevState.abhaAddress,
    //       isError: true,
    //       message: 'AbhaAddress cannot be blank. Enter valid Abha Address.',
    //     },
    //   }));
    //   checkError = true;
    // }
    if (!childFormState.dateOfreg.value) {
      setChildFormState((prevState: any) => ({
        ...prevState,
        dateOfreg: {
          ...prevState.dateOfreg,
          isError: true,
          message: 'Date of registration cannot be blank. Select valid date of registration.',
        },
      }));
      checkError = true;
    }
    if (!childFormState.timeOfreg.value) {
      setChildFormState((prevState: any) => ({
        ...prevState,
        timeOfreg: {
          ...prevState.timeOfreg,
          isError: true,
          message: 'Time of registration cannot be blank. Select valid time of registration.',
        },
      }));
      checkError = true;
    }
    if (!childFormState.relationWithChild.value || !childFormState.relationWithChild.id) {
      setChildFormState((prevState: any) => ({
        ...prevState,
        relationWithChild: {
          ...prevState.relationWithChild,
          isError: true,
          message: 'Relation with Child cannot be blank. Select valid relation with Child.',
        },
      }));
      checkError = true;
    }
    if (!childFormState.timeOfbirth.value || !dayjs(childFormState.timeOfbirth.value).isValid()) {
      setChildFormState((prevState: any) => ({
        ...prevState,
        timeOfbirth: {
          ...prevState.timeOfbirth,
          isError: true,
          message: CHILD_ERRORS.TIME_OF_BIRTH,
        },
      }));
      checkError = true;
    }
    if (!childFormState.maturity.value) {
      setChildFormState((prevState: any) => ({
        ...prevState,
        maturity: {
          ...prevState.maturity,
          isError: true,
          message: 'Maturity cannot be blank. Select valid maturity.',
        },
      }));
      checkError = true;
    }
    if (!childFormState.weight.value) {
      setChildFormState((prevState: any) => ({
        ...prevState,
        weight: {
          ...prevState.weight,
          isError: true,
          message: 'Weight cannot be blank. Please enter valid weight.',
        },
      }));
      checkError = true;
    }
    if (childFormState.weight.value < 500) {
      setChildFormState((prevState: any) => ({
        ...prevState,
        weight: {
          ...prevState.weight,
          isError: true,
          message: 'Weight cannot be less than 500gms',
        },
      }));
      checkError = true;
    }
    if (!childFormState.facilityType.value) {
      setChildFormState((prevState: any) => ({
        ...prevState,
        facilityType: {
          ...prevState.facilityType,
          isError: true,
          message: 'Facility Type cannot be blank.',
        },
      }));
      checkError = true;
    }
    if (!childFormState.facilityName.value) {
      setChildFormState((prevState: any) => ({
        ...prevState,
        facilityName: {
          ...prevState.facilityName,
          isError: true,
          message: 'Facility Name cannot be blank.',
        },
      }));
      checkError = true;
    }
    if (!childFormState.healthProviderName.value) {
      setChildFormState((prevState: any) => ({
        ...prevState,
        healthProviderName: {
          ...prevState.healthProviderName,
          isError: true,
          message: 'Health Provider Name cannot be blank.',
        },
      }));
      checkError = true;
    }
    if (!childFormState.dateOfVisit.value) {
      setChildFormState((prevState: any) => ({
        ...prevState,
        dateOfVisit: {
          ...prevState.dateOfVisit,
          isError: true,
          message: 'Date of Visit cannot be blank.',
        },
      }));
      checkError = true;
    }
    if (fatherToggle && !isMotherAlive) {
      if (!fatherFormState.name.value) {
        setFatherFormState((prevState: any) => ({
          ...prevState,
          name: {
            ...prevState.name,
            isError: true,
            message:
              'Father Name cannot be blank. Please enter valid Father name.',
          },
        }));
        checkError = true;
      }
      if (!fatherFormState.mob.value) {
        setFatherFormState((prevState: any) => ({
          ...prevState,
          mob: {
            ...prevState.mob,
            isError: true,
            message:
              'Father Phone number cannot be blank. Please enter valid Phone number.',
          },
        }));
        checkError = true;
      }
    }
    if (guardianToggle && !isMotherAlive) {
      if (!guardianFormState.name.value) {
        setGuardianFormState((prevState: any) => ({
          ...prevState,
          name: {
            ...prevState.name,
            isError: true,
            message:
              'Guardian Name cannot be blank. Please enter valid guardian name.',
          },
        }));
        checkError = true;
      }
      if (!guardianFormState.mob.value) {
        setGuardianFormState((prevState: any) => ({
          ...prevState,
          mob: {
            ...prevState.mob,
            isError: true,
            message:
              'Guardian Phone number cannot be blank. Please enter valid Phone number.',
          },
        }));
        checkError = true;
      }
    }
    if (motherToggle && !isMotherAlive) {
      if (!motherFormState.name.value) {
        setMotherFormState((prevState: any) => ({
          ...prevState,
          name: {
            ...prevState.name,
            isError: true,
            message:
              'Mother Name cannot be blank. Please enter valid mother name.',
          },
        }));
        checkError = true;
      }
      if (!motherFormState.mob.value) {
        setMotherFormState((prevState: any) => ({
          ...prevState,
          mob: {
            ...prevState.mob,
            isError: true,
            message:
              'Mother Phone number cannot be blank. Please enter valid Phone number.',
          },
        }));
        checkError = true;
      }
    }
    if (!checkError) {
      setIsFormCompleted(true);
      setPerc(100);
      return true;
    }
    else {
      setIsFormCompleted(false);
      setPerc(0);
      return false;
    }
  }

  const formateDateToTimeStamp = (date: any, time: any) => {
    const dateOfBirth = dayjs(date).format('YYYY-MM-DD');
    const timeOfBirth = dayjs(time).format('HH:mm');

    const combinedDateTime = `${dateOfBirth} ${timeOfBirth}`;
    const timestampWithoutTimeZone = dayjs(combinedDateTime).format('YYYY-MM-DD HH:mm:ss');

    return timestampWithoutTimeZone;
  }
  const getProcessIdByCode = (arr: any[], code: string) =>
  arr?.find((item: any) => item.reg_process_code === code)?.reg_process_id;

  const getLoginIdByCode = (arr: any[], code: string) =>
  arr?.find((item: any) => item.login_process_code === code)?.login_process_id;

  const handleProcessIds = async () => {
    try {
      const staticBenfCreateDetails = await getDataWithCache<any>(
        `${endpoints.getStaticChildCreateDetails}`,
      );
      const regData = staticBenfCreateDetails.data.registrationProcessData;
      const loginData = staticBenfCreateDetails.data.loginProcessData;

      if (!isTempBenf) {
        const tempData = regData?.find(
          (item: any) => item.reg_process_code === '6003',
        );
        if (tempData) {
          setRegId('');
          setLoginId('');
          dispatch(updateChild('childRegistrationId', {}));
        }
      } else if (
        childRegistrationId?.key ===
        CHILD_REGISTRATION_KEYS.BAAL_ABHA_USING_PARENTS
      ) {
        setRegId(getProcessIdByCode(regData, '6001'));
        setLoginId(getLoginIdByCode(loginData, '5005'));
      } else {
        if (beneficiaryAuthType === AUTH_TYPES.DEMOGRAPHICS) {
          setRegId(getProcessIdByCode(regData, '6002'));
        } else if (
          beneficiaryAuthType === AUTH_TYPES.OTP ||
          beneficiaryRedgeOption === BENEFICIARY_OPTIONS.PHONE_NUMBER
        ) {
          setRegId(getProcessIdByCode(regData, '6001'));
        }

        let loginCode = '';
        switch (beneficiaryRedgeOption) {
          case BENEFICIARY_OPTIONS.AADHAAR:
            loginCode = '5002';
            break;
          case BENEFICIARY_OPTIONS.ABHA:
            loginCode = '5001';
            break;
          case BENEFICIARY_OPTIONS.PHONE_NUMBER:
            loginCode = '5003';
            break;
          default:
            break;
        }

        if (
          beneficiaryAuthType === AUTH_TYPES.OTP &&
          beneficiaryRedgeOption === BENEFICIARY_OPTIONS.AADHAAR
        ) {
          setIsAadhaarFlow(true);
        }

        if (loginCode) {
          const loginIdVal = getLoginIdByCode(loginData, loginCode);
          if (loginIdVal) setLoginId(loginIdVal);
        }
      }
    } catch (error: any) {
      errorLogger(error?.response?.data || error?.response || error);
    }
  };

  const handleChildSubmit = async () => {
   setIsLoading(true)
    const isValid = handleChildSave();
    if (!isValid) {
     setIsLoading(false)
      return;
    }
    const hbncPeriodDetails = getPNCDetails(childFormState.dob.value);
    const hbycPeriodDetails = getHBYCPeriodDetails(childFormState.dob.value);    
    const getReqId = (id: string) => {
      return !isTempBenf ? '' : id;
    }
    const childPayload: any = {
      registrationFlowId: getReqId(childRegistrationId?.id),
      loginProcessId: getReqId(loginId),
      registrationProcessId: getReqId(regId),
      pregnancyId: null,
      deliveryStatusId: null,
      childName: childFormState.name.value.trim(),
      abhaId: childFormState.childAbha.value ? childFormState.childAbha.value : null,
      abhaAddress: childFormState.abhaAddress.value ? childFormState.abhaAddress.value : null,
      beneficiaryDob: formateDateToTimeStamp(childFormState.dob.value, childFormState.timeOfbirth.value),
      genderId: childFormState.gender.id,
      weightAtBirth: childFormState.weight.value,
      maturityStatusId: childFormState.maturity.id,
      parentId: beneficiary?.benef_id,
      isMotherAlive: isMotherAlive,
      relationshipWithChild: childFormState.relationWithChild.id,
      facilityNameId: childFormState?.facilityName?.id,
      healthProviderId: childFormState?.healthProviderName?.id,
      ashaNameId: childFormState?.ashaName?.id || null,
      isreqFatherdetails: fatherToggle,
      isreqGurdiandetails: guardianToggle,
      isreqMotherdetails: motherToggle,
      fatherName: fatherFormState.name.value,
      fatherMobile: fatherFormState.mob.value,
      motherName:motherFormState.name.value,
      motherMobile:motherFormState.mob.value,
      guardianName: guardianFormState.name.value,
      guardianMobile: guardianFormState.mob.value,
      filePath: null,
      url: null,
      description: '',
      parentUserId: userId,
      parentUserTypeId: null,
      parentRoleId: null,
      hbncOneStartDate:hbncPeriodDetails[0].startDate,
      hbncOneEndDate:hbncPeriodDetails[0].endDate,
      hbncTwoStartDate:hbncPeriodDetails[1].startDate,
      hbncTwoEndDate:hbncPeriodDetails[1].endDate,
      hbncThreeStartDate:hbncPeriodDetails[2].startDate,
      hbncThreeEndDate:hbncPeriodDetails[2].endDate,
      hbncFourStartDate:hbncPeriodDetails[3].startDate,
      hbncFourEndDate:hbncPeriodDetails[3].endDate,
      hbncFiveStartDate:hbncPeriodDetails[4].startDate,
      hbncFiveEndDate:hbncPeriodDetails[4].endDate,
      hbncSixStartDate:hbncPeriodDetails[5].startDate,
      hbncSixEndDate:hbncPeriodDetails[5].endDate,
      hbncSevenStartDate:hbncPeriodDetails[6]?.startDate,
      hbncSevenEndDate:hbncPeriodDetails[6]?.endDate,
      hbycOneStartDate:hbycPeriodDetails[0].startDate,
      hbycOneEndDate:hbycPeriodDetails[0].endDate,
      hbycTwoStartDate:hbycPeriodDetails[1].startDate,
      hbycTwoEndDate:hbycPeriodDetails[1].endDate,
      hbycThreeStartDate:hbycPeriodDetails[2].startDate,
      hbycThreeEndDate:hbycPeriodDetails[2].endDate,
      hbycFourStartDate:hbycPeriodDetails[3].startDate,
      hbycFourEndDate:hbycPeriodDetails[3].endDate,
      consentTemplateDetails:childConsentIds?  childConsentIds?.map((item:any) => ({ consent_template_id: item })) : null,
      kycVerified: isAadhaarFlow ? true : regChildDetails?.kycVerified || false,
      parentMobile: benfDetails?.beneficiary.mob,
      processChannel: 'web',
    };
    try {
      const isAbhaExists = await isABHAExists();
      if (!isAbhaExists) {
        const encodedPayload = encodeWithKeyAndShift(JSON.stringify(childPayload))
        const res = await postDataJSON<any>(`${endpoints.createChildBeneficiary}`,{data:encodedPayload} );
          toast.success(benef_const.childCreateMessage, {
          position: 'top-center',
        });
       setIsLoading(false)
       navigate(-1);
       dispatch(setChildBenefList([]));
        if (childImageData instanceof FormData) {
          childImageData.append("imageType", "beneficiary_profile");
          childImageData.append("objectId",res.data.data[0].benef_id);
          const responses = await axios.post(`${endpoints.beneficiaryImageUpload}`, childImageData, Auth.loggedInWithMultipart())
          dispatch(updateChild('childConsentIds',[]));
        }
    
      } else {
        setIsLoading(false)
        toast.error(benef_const.abhaLinkedErrorMessage, { position: 'top-center' });
        navigate(`/beneficiaries/view/${beneficiary?.benef_id}`);
        dispatch(updateChild("updateChildVerifyFromView", false));
      }
    } catch(error:any){
     setIsLoading(false)
      errorLogger(error?.response?.data||error?.response||error)
    }
  }; 

  const isABHAExists = async () => {
    try {
      if(childFormState.childAbha.value) {
        const encodedNumber = encodeWithKeyAndShift(JSON.stringify({abhaId:childFormState.childAbha.value}));
        const abhaResponse = await postDataJSON<any>(`${endpoints.checkAbhaIdExist}`,{data:encodedNumber});
        const decodedResponse= JSON.parse(decodeWithKeyAndShift(abhaResponse.data)); 
        const abhaRes=decodedResponse[0];
        return abhaRes.check_abha_id_exists;
      } else {
        return false;
      }
      
    } catch (error: any) {
      errorLogger(error?.response?.data || error?.response || error)
    }
      
  }

  const handleUpdateChildSubmit = async () => {
    if (!benfDetails?.childBenfId) return;
    const isValid = handleChildSave();
    if (!isValid) {
      return;
    }
    const childPayload: any = {
      childBenfId:benfDetails.childBenfId,
      childName: childFormState.name.value.trim(),
      abhaId: childFormState.childAbha.value ? childFormState.childAbha.value : null,
      beneficiaryDob: formateDateToTimeStamp(childFormState.dob.value, childFormState.timeOfbirth.value),
      genderId: childFormState.gender.id,
      weightAtBirth: childFormState.weight.value,
      maturityStatusId: childFormState.maturity.id,
      isMotherAlive: isMotherAlive,
      url: null,
      description: '',
      parentUserId: userId,
      consentTemplateDetails:childConsentIds?  childConsentIds?.map((item:any) => ({ consent_template_id: item })) : null,    
      kycVerified: child?.is_kyc_verified,
      abhaVerified: true,
      parentMobile: benfDetails?.beneficiary.mob || benfDetails?.beneficiaryDetails?.mob,
      processChannel: 'web'
    };
    try {
      const isAbhaExists = await isABHAExists();
      if (!isAbhaExists) {
        const encodedPayload = encodeWithKeyAndShift(JSON.stringify(childPayload))
        const res = await putDataJSON<any>(`${endpoints.updateChild}`,{data:encodedPayload});
        if (childImageData instanceof FormData) {
          childImageData.append("imageType", "beneficiary_profile");
          childImageData.append("objectId", benfDetails.childBenfId);
          const responses = await axios.post(`${endpoints.beneficiaryImageUpload}`, childImageData, Auth.loggedInWithMultipart())
        }
        const successMessage = benef_const.childUpdateMessage 

        toast.success(successMessage, { position: 'top-center' });
        const redirectPath = childFlow === benef_const.childVerifyFlow || childFlow === benef_const.childCreateFlow ? "/beneficiaries" 
        : `/beneficiaries/view/${benfDetails.childBenfId}`;
        navigate(redirectPath);
        dispatch(updateChild("updateChildVerifyFromView", false)); 
      }
      else{
        toast.error(benef_const.abhaLinkedErrorMessage, { position: 'top-center' });
        const redirectPath = childFlow === benef_const.childVerifyFlow || childFlow === benef_const.childCreateFlow ? "/beneficiaries" 
        : `/beneficiaries/view/${benfDetails.childBenfId}`;
        navigate(redirectPath);
        dispatch(updateChild("updateChildVerifyFromView", false)); 

      }
    }catch(error:any){
      errorLogger(error?.response?.data||error?.response||error)
    }
  };


  const handleFileChange = async (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const selectedFile = event.target.files && event.target.files[0];
    setImageError('');
    if (selectedFile) {
      const fileType = selectedFile.type;
      const fileSize = selectedFile.size;
      if (fileSize > 1048576) {
        setImageError('File size must be less than or equal to 1MB');
        return;
      }
      if (!['image/jpeg', 'image/png', 'image/jpg'].includes(fileType)) {
        setImageError('Only JPG, JPEG and PNG images are allowed');
        return;
      }
      setNewImageUrl(URL.createObjectURL(selectedFile));
      setUploadMethod(null);
      const file = selectedFile;
      const formData = new FormData();
      formData.append('file', file);
      dispatch(updateChild('childImageData', formData));
      dispatch(updateChild('childModalImageFile', file));
    }
  };

  const handleUploadClick = (method: 'local' | 'url') => {
    inputRef.current?.click();
    setUploadMethod(method);
  };



  return (
    <>
     <Loading isLoading={isLoading} />
      <div className="app-child-wrapper">
        <header className="view-header">
          <div className="logo-wrapper">
            <NationalEmblem className="logo" />
            <div className="name-wrapper">
              <div className="name-wrapper-title">
                JANANI
              </div>
              <div className="name-wrapper-subtext">
                Journey of Antenatal, Natal and Neonatal Integrated Care
              </div>
              <div className="name-wrapper-subtext" style={{ fontWeight: 'bold' }}>Sehat ke Sath, Every Step of Care</div>
            </div>
          </div>
          <div className="view-route">
            <BreadcrumbComponent
              breadcrumbItemName={[
                { value: page, label: 'Service Provider' },
                { value: page, label: 'Beneficiary Profile' },
              ]}
            />
          </div>
        </header>
        <main className="view-content">
          <div className="view-profile-buttons-child">
            <div className="view-profile">
              <CommonHamburgar>
                <LeftNavBar
                  navItems={tabs}
                  currentTab={currentTab}
                  handleNavClick={setCurrentTab}
                />
              </CommonHamburgar>
              <Button
                onClick={() => {
                  handleBack();
                }}
                disabled={false}
                id=""
                buttonName={''}
                colorType={'verticalbackbutton'}
                icon={<BackArrowsvg />}
                iconPosition={'left'}
              />
              {
                benfImageUrl ? <img
                  className="profile-picture"
                  src={benfImageUrl}
                  alt='Profile Image'
                /> :
                  <img
                    className="profile-picture"
                    src={profilePic}
                    alt="Profile Image"
                  />
              }
              <div className="beneficiary-details">
                <div className="name-type">
                  <div
                    style={{
                      margin: '10px 0px',
                      display: 'flex',
                      gap: '5px',
                    }}
                  >
                    {`${beneficiary?.benf_name}`}
                    <BadgesComponent
                      className="beneficiary-status"
                      badgeName={beneficiary?.abha_id ? 'Verified' : 'Not Verified'}
                      variant={beneficiary?.abha_id ? "success" : "warning"}
                      badgeType="case5"
                    />
                  </div>
                </div>
                <div
                  className="beneficiary-address-details"
                  style={{ margin: '10px 0px', display: 'flex', gap: '10px' }}
                >
                  <div>
                    {benfDetails?.beneficiaryDetails?.gender_name === 'Male' ? <ManIcon /> : <WomanIcon />}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="child_header_progress_bar">
            <ProgressBarComponent
              progressBarPercentage={perc}
              isLabelNeeded={false}
              className={''}
              variant={'primary'}
            />
          </div>
          <div className="content">
            <LeftNavBar
              navItems={tabs}
              currentTab={currentTab}
              handleNavClick={setCurrentTab}
            />
            <div className="child-tab-content">
              <div className="overview">
                <BadgesComponent
                  className="over-badge"
                  badgeName={benfDetails?.beneficiaryDetails?.gender_name === 'Male'?"Father/ Guardian Details":"Mother/ Guardian Details"}
                  variant="primary-1"
                  badgeType="case5"
                />

                <div className="overview-details">
                  <div>
                    <label className="overview-details-label">Name</label>
                    {<div className="overview-details-value">{beneficiary?.benf_name}</div>}
                  </div>
                  <div>
                    <label className="overview-details-label">
                      Spouse Name
                    </label>
                    <div className="overview-details-value">{beneficiary?.spouse_name}</div>
                  </div>
                  <div>
                    <label className="overview-details-label">
                      Beneficiary Mobile Number
                    </label>
                    <div className="overview-details-value">{beneficiary?.mob}</div>
                  </div>
                  <div>
                    <label className="overview-details-label">
                      Alternative Mobile Number
                    </label>
                    <div className="overview-details-value">{beneficiary?.alternate_mob}</div>
                  </div>
                  <div>
                    <label className="overview-details-label">ABHA Number</label>
                    <div
                      className="overview-details-value"
                      style={{ display: 'flex', gap: '10px' }}
                    >
                      {beneficiary?.abha_id}
                      {beneficiary?.abha_id && <BadgesComponent
                        className="beneficiary-status"
                        badgeName={'Verified'}
                        variant={'success'}
                        badgeType="case5"
                      />}
                    </div>
                  </div>
                </div>
              </div>
              <hr className="details-divider" />
              <div className="child-form-details">
                <BadgesComponent
                  className="over-badge"
                  badgeName="Child General Details"
                  variant="primary-1"
                  badgeType="case5"
                />
                {(createSubmitClicked || verifySubmitClicked || !isTempBenf) && (
                  <div
                    style={{
                      display: 'flex',
                      gap: '10px',
                      margin: '14px 0px 20px 0px',
                    }}
                  >
                    <div className="modal-image">
                      {newImageUrl ? (
                        <img
                          className="profile-picture"
                          src={newImageUrl}
                          alt="Profile Image"
                        />
                      ) : (
                        <img
                          className="profile-picture"
                          src={profilePic}
                          alt="Profile Image"
                        />
                      )}
                    </div>
                    <div>
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'row',
                          gap: '10px',
                        }}
                      >
                        <div>
                          <div>
                            <div
                              style={{
                                display: 'flex',
                                flexDirection: 'row',
                                gap: '10px',
                              }}
                            >
                              <Button
                                onClick={() => {
                                  handleUploadClick('local')
                                }}
                                disabled={false}
                                id="add-profile-picture"
                                buttonName={newImageUrl ? 'Edit Profile Picture' : '+ Add Profile Picture'}
                                colorType={'primary'}
                                iconPosition={'left'}
                                icon={newImageUrl ? <EditIcon /> : ''}
                              />
                              <span className="tooltip-profile-pic">
                                <CustomTooltip
                                  text={
                                    'File size must be less than or equal to 1MB and Only JPG, JPEG and PNG images are allowed'
                                  }
                                />
                              </span>
                            </div>

                            {imageError.length > 0 && (
                              <InfoBar
                                variant="danger"
                                message={imageError}
                                className="input_field_class profile-pic-error"
                              />
                            )}
                          </div>
                          <input
                            type="file"
                            accept=".jpg,.jpeg,.png"
                            onChange={handleFileChange}
                            className="profile-picture-hidden-input"
                            ref={inputRef}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                <form className="form_container_child_details">
                  <CommonFormFields
                    formData={childData}
                    formState={childFormState}
                    handleFormChange={handleChildFormChange}
                    verified={verify}
                    onClickVerify={onClickVerify}
                  />
                </form>
              </div>
              {!childVerifyFromGrid &&<div className='parent-toggle-container' >
                {shouldRenderFatherDetails && (<div >
                  <ToggleButton
                    title="Add Father Details?"
                    handleToggle={handleToggleChange}
                    toggleType="father"
                    isToggled={fatherToggle}
                    isMotherAlive={isMotherAlive}
                  />
                  {fatherToggle && (
                    <form className="form_container_parent_details">
                      <CommonFormFields
                        formData={fatherData}
                        formState={fatherFormState}
                        handleFormChange={handleFatherFormChange}
                      />
                    </form>
                  )}
                </div>)}
                {shouldRenderMotherDetails && (<div >
                  <ToggleButton
                    title="Add Mother Details?"
                    handleToggle={handleToggleChange}
                    toggleType="mother"
                    isToggled={motherToggle}
                    isMotherAlive={isMotherAlive}
                  />
                  {motherToggle && (
                    <form className="form_container_parent_details">
                      <CommonFormFields
                        formData={motherData}
                        formState={motherFormState}
                        handleFormChange={handleMotherFormChange}
                      />
                    </form>
                  )}
                </div>)}
                {shouldRenderGuardianDetails() && (<div>
                  <ToggleButton
                    title="Add Guardian Details?"
                    handleToggle={handleToggleChange}
                    toggleType="guardian"
                    isToggled={guardianToggle}
                    isMotherAlive={isMotherAlive}
                  />
                  {guardianToggle && (
                    <form className="form_container_parent_details">
                      <CommonFormFields
                        formData={guardianData}
                        formState={guardianFormState}
                        handleFormChange={handleGuardianFormChange}
                      />
                    </form>
                  )}
                </div>)}
              </div>}
              <div className="child-action-buttons">
                <Button
                  onClick={() => {
                    navigate(-1);
                    dispatch(updateChild('verifyChildFromGridData', {}));
                    dispatch(updateChildVerifyFromGrid(false));
                    dispatch(updateChild("updateChildVerifyFromView", false)); 
                    dispatch(updateChild("childFlow", ''));
                  }}
                  id=""
                  buttonName={'Cancel'}
                  colorType={'primary'}
                  icon={''}
                  iconPosition={'right'}
                />
                <Button
                  onClick={handleChildSave}
                  id=""
                  buttonName={'Save'}
                  colorType={'primary'}
                  icon={''}
                  iconPosition={'right'}
                />
                <Button
                  onClick={childVerifyFromGrid?handleUpdateChildSubmit: handleChildSubmit}
                  id=""
                  buttonName={'Submit'}
                  colorType={'primary'}
                  icon={''}
                  disabled={!isFormCompleted}
                  iconPosition={'right'}
                />
              </div>
            </div>
          </div>
        </main>
      </div>
      <div>
        {alertModalOpen && (
          <AlertPopup
            showModal={alertModalOpen}
            closeModal={closeAlertModal}
            title={'Date of birth already exist, is the child twin ?'}
          />
        )}
      </div>
    </>
  );
};

export default CreateNewChild;
